import { styled } from "@mui/material";

export const ActionModalHeaderStyled = styled("div")({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  paddingBottom: "12px",
  zIndex: 1,
  boxShadow: "0 1px 2px -2px rgba(0, 0, 0, 0.5)",
  "& .header-row": {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    "&.space-between": {
      justifyContent: "space-between",
    },
  },
  "& .header-title": {
    fontSize: "28px",
    fontWeight: 600,
    color: "#0f6cbd",
  },
  "& .header-btn-group": {
    display: "flex",
    flexWrap: "nowrap",
    alignItems: "center",
    gap: "8px",
  },
  "& .action-status-badge": {
    fontSize: "12px",
    color: "#ffffff",
    padding: "6px 12px",
    borderRadius: "6px",
    "&.success": {
      backgroundColor: "#6fae84",
    },
    "&.error": {
      backgroundColor: "d46b6b",
    },
    "&.pending": {
      backgroundColor: "#e59805",
    },
  },
  "& .action-assignment": {
    display: "flex",
    alignItems: "center",
    gap: "0.25rem",
  },
  "& .action-assignment-type": {
    color: "#424242",
  },
  "& .action-button": {
    height: "2rem",
  },
});
